import clsx from 'clsx';
import { useNavigate } from 'react-router';
import { useAuth } from '../../../lib/auth';
import AuthLayout from '../../layouts/AuthLayout';
import Skeleton from '../../../components/Skeleton';
import { PlanWeek } from '../../../components/plan/PlanWeek';
import { PlanTabs } from '../../../components/plan/PlanTabs';
import { usePlan } from '../../../lib/plan/usePlan';

export default function PlanPage() {
    useAuth({
        middleware: 'auth',
        redirectTo: '/',
        tmp: 'PlanPage',
    });

    const navigate = useNavigate();
    const { plan, isLoading, mutate } = usePlan();

    if (isLoading) {
        return (
            <AuthLayout>
                <main
                    className={clsx(
                        'relative',
                        'mx-auto box-content max-w-2xl py-9',
                        'px-4 sm:px-8 md:px-10'
                    )}
                >
                    <Skeleton className="mb-6 h-64 w-full rounded-2xl" />
                    <Skeleton
                        count={5}
                        className="mb-6 h-16 w-full rounded-2xl"
                    />
                </main>
            </AuthLayout>
        );
    }

    if (plan === null) {
        navigate('/plan-na-miru/dotaznik');
        return null;
    }

    const firstLockedWeek = plan.weeks.find((week) => week.locked);

    return (
        <AuthLayout>
            <main
                className={clsx(
                    'relative',
                    'mx-auto box-content max-w-2xl py-9',
                    'px-4 sm:px-8 md:px-10'
                )}
            >
                <h1 className="mb-6">Plán na míru</h1>
                <div className="mb-10">
                    <PlanTabs />
                </div>
                <p className="mb-8 text-ink-800">
                    Při pěti cvičeních týdně máte hotovo za pár týdnů.
                </p>

                <div className="grid gap-10">
                    {plan.weeks.map((week) => (
                        <PlanWeek
                            key={week.week}
                            week={week}
                            showUpsell={week === firstLockedWeek}
                            onMutate={() => mutate()}
                        />
                    ))}
                </div>
            </main>
        </AuthLayout>
    );
}
